import { render, staticRenderFns } from "./banners-s-2.vue?vue&type=template&id=2b2fa2cc"
import script from "./banners-s-2.vue?vue&type=script&lang=js"
export * from "./banners-s-2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports